/**
 * Tailles de page des listes du back-office.
 * Shared between server (user-preferences.controller.js) and client
 * (useListPreferences / Pagination) — single source of truth.
 */

/**
 * Valeur sentinelle de l'option « Tout afficher ».
 *
 * Volontairement une borne haute plutôt qu'un « illimité » : certaines listes
 * (logs surtout) peuvent contenir des centaines de milliers de lignes, qu'aucun
 * navigateur ne rend correctement. Au-delà de cette borne, la pagination
 * réapparaît naturellement (totalPages > 1) au lieu de figer l'écran.
 */
export const ALL_PAGE_SIZE = 100000;

// Options proposées à l'utilisateur, dans l'ordre d'affichage.
export const PAGE_SIZE_OPTIONS = [10, 50, 100, 500, 1000, ALL_PAGE_SIZE];

// Valeur par défaut quand aucune préférence n'a encore été enregistrée.
export const DEFAULT_PAGE_SIZE = 50;

/**
 * Plafond serveur pour la liste des logs (indépendant de ALL_PAGE_SIZE).
 *
 * La table logs peut compter des centaines de milliers de lignes, dont chacune
 * sérialise un JSON `details` potentiellement volumineux. Un SELECT non plafonné
 * (notamment via l'option « Tout afficher ») produit une réponse de plusieurs
 * centaines de Mo et un pic mémoire côté Node : la valeur ci-dessous s'applique
 * quelle que soit la limite demandée par le client.
 */
export const LOGS_MAX_LIMIT = 5000;

/**
 * Libellé d'une option de taille de page.
 * @param {number|string} size
 * @returns {string}
 */
export function pageSizeLabel(size) {
  return Number(size) === ALL_PAGE_SIZE ? 'Tout afficher' : `${size} par page`;
}

/**
 * Taille d'une tranche de liste.
 *
 * Les grandes tailles de page (500, 1000, « Tout afficher ») étaient servies en
 * une seule requête : plusieurs Mo de JSON, un pic mémoire côté serveur et un
 * rendu figé le temps de peindre des milliers de lignes. Toute page plus grande
 * que cette valeur est désormais servie en plusieurs tranches, la suivante étant
 * demandée quand le bas de la liste approche du viewport. Les tailles
 * inférieures (10, 50, 100) arrivent d'un bloc, comme avant.
 */
export const PROGRESSIVE_CHUNK_SIZE = 200;
